
export default function ScheduleSection() {
  const scheduleData = [
    {
      time: '6:30AM',
      location: 'GIBSONS',
      monday: '',
      tuesday: 'Sculpt Fusion',
      wednesday: 'Steady Flow',
      thursday: 'Steady Flow',
      friday: 'Dynamic Flow',
      saturday: '',
      sunday: ''
    },
    {
      time: '7:00AM',
      location: 'SECHELT',
      monday: '',
      tuesday: 'Steady Flow',
      wednesday: 'Dynamic Flow',
      thursday: 'Sculpt Fusion',
      friday: '',
      saturday: '',
      sunday: ''
    },
    {
      time: '9:30AM',
      location: 'GIBSONS',
      monday: 'Steady Flow',
      tuesday: 'Steady Flow',
      wednesday: 'Steady Flow',
      thursday: 'Mat Pilates Fusion',
      friday: 'Steady Flow',
      saturday: '9 AM Dynamic Flow',
      sunday: 'Dynamic Flow'
    },
    {
      time: '9:30AM',
      location: 'SECHELT',
      monday: 'Slow Flow',
      tuesday: 'Dynamic Flow',
      wednesday: 'Sculpt Fusion',
      thursday: 'Steady Flow',
      friday: 'Dynamic Flow',
      saturday: '9 AM Dynamic Flow',
      sunday: 'Steady Flow'
    },
    {
      time: '11:00AM',
      location: 'GIBSONS',
      monday: 'Slow Flow',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: 'Slow Flow',
      saturday: 'Slow Flow',
      sunday: ''
    },
    {
      time: '11:00AM',
      location: 'SECHELT',
      monday: 'Mat Pilates Fusion',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: 'Sculpt Fusion',
      saturday: 'Kids Aerial Drop-In',
      sunday: ''
    },
    {
      time: '5:30PM',
      location: 'GIBSONS',
      monday: 'Dynamic Flow',
      tuesday: 'Circus Core',
      wednesday: 'Sculpt Fusion',
      thursday: '',
      friday: '',
      saturday: '',
      sunday: ''
    },
    {
      time: '5:30PM',
      location: 'SECHELT',
      monday: 'Sculpt Fusion',
      tuesday: '',
      wednesday: '6 PM Mat Pilates Fusion',
      thursday: 'Circus Core',
      friday: '',
      saturday: '',
      sunday: ''
    },
    {
      time: '7:00PM',
      location: 'GIBSONS',
      monday: '',
      tuesday: 'Steady Flow',
      wednesday: 'Deep Rest: Yin Yoga',
      thursday: 'Flow to Yin',
      friday: '',
      saturday: '',
      sunday: 'Deep Rest: Yin Yoga'
    },
    {
      time: '7:00PM',
      location: 'SECHELT',
      monday: 'Steady Flow',
      tuesday: 'Slow Flow',
      wednesday: '',
      thursday: 'Deep Rest: Yin Yoga',
      friday: '',
      saturday: '',
      sunday: 'Karma Flow and Sound'
    }
  ];

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  return (
      <section className="pb-16 bg-white min-h-screen">
        <section
            className="relative py-6 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: 'url(/img/herobg.png)'
            }}
        >
          <div className="absolute inset-0 bg-white/70"></div>
          <div className="relative max-w-7xl mx-auto px-6">
            <h1 className="hero-heading text-3xl font-bold text-[#00889D] ">
              Our Schedule
            </h1>
          </div>
        </section>

        <div style={{minHeight: '300px'}}>
          <div data-mariana-integrations="/schedule/daily/48541?locations=48717"></div>
        </div>

        {/*<div className="max-w-7xl pt-6 mx-auto px-6">*/}
        {/*  /!* Header *!/*/}
        {/*  <div className="grid pb-8 grid-cols-2 md:grid-cols-3 gap-2">*/}
        {/*    <div className="flex items-center gap-2">*/}
        {/*      <div className="w-4 h-4 bg-orange-200 rounded"></div>*/}
        {/*      <span className="text-sm text-gray-700">Yoga</span>*/}
        {/*    </div>*/}
        {/*    <div className="flex items-center gap-2">*/}
        {/*      <div className="w-4 h-4 bg-teal-200 rounded"></div>*/}
        {/*      <span className="text-sm text-gray-700">Fitness</span>*/}
        {/*    </div>*/}
        {/*    <div className="flex items-center gap-2">*/}
        {/*      <i className="ri-fire-fill text-orange-500 text-lg"></i>*/}
        {/*      <i className="ri-fire-fill text-orange-500 text-lg"></i>*/}
        {/*      <span className="text-sm text-gray-700">Hot Classes</span>*/}
        {/*    </div>*/}
        {/*    <div className="flex items-center gap-2">*/}
        {/*      <div className="w-4 h-4 bg-cyan-200 rounded"></div>*/}
        {/*      <span className="text-sm text-gray-700">Yoga & Fitness</span>*/}
        {/*    </div>*/}
        {/*    <div className="flex items-center gap-2">*/}
        {/*      <div className="w-4 h-4 bg-purple-200 rounded"></div>*/}
        {/*      <span className="text-sm text-gray-700">Workshops</span>*/}
        {/*    </div>*/}

        {/*    <div className="flex items-center gap-2">*/}
        {/*      <i className="ri-fire-fill text-orange-500 text-lg"></i>*/}
        {/*      <span className="text-sm text-gray-700">Warm Classes</span>*/}
        {/*    </div>*/}
        {/*  </div>*/}

        {/*  /!* Desktop Schedule Table *!/*/}
        {/*  <div className="hidden lg:block bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">*/}
        {/*    <div className="bg-gradient-to-r from-[#0C948D] to-[#00889D] text-white">*/}
        {/*      <div className="grid grid-cols-9 gap-0">*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Time</div>*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Monday</div>*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Tuesday</div>*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Wednesday</div>*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Thursday</div>*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Friday</div>*/}
        {/*        <div className="p-4 font-semibold text-center border-r border-teal-500">Saturday</div>*/}
        {/*        <div className="p-4 font-semibold text-center">Sunday</div>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*    <div className="divide-y divide-gray-200">*/}
        {/*      {scheduleData.map((row, index) => (*/}
        {/*          <div key={index} className="grid grid-cols-9 gap-0 hover:bg-gray-50 transition-colors">*/}
        {/*            <div className="p-4 font-medium text-teal-600 border-r border-gray-200 text-center bg-gray-50">*/}
        {/*              <div className="text-sm font-semibold">{row.time}</div>*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center border-r border-gray-200">*/}
        {/*              {row.monday && (*/}
        {/*                  <div className="bg-orange-100 text-orange-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.monday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center border-r border-gray-200">*/}
        {/*              {row.tuesday && (*/}
        {/*                  <div className="bg-teal-100 text-teal-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.tuesday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center border-r border-gray-200">*/}
        {/*              {row.wednesday && (*/}
        {/*                  <div className="bg-cyan-100 text-cyan-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.wednesday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center border-r border-gray-200">*/}
        {/*              {row.thursday && (*/}
        {/*                  <div className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.thursday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center border-r border-gray-200">*/}
        {/*              {row.friday && (*/}
        {/*                  <div className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.friday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center border-r border-gray-200">*/}
        {/*              {row.saturday && (*/}
        {/*                  <div className="bg-pink-100 text-pink-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.saturday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*            <div className="p-3 text-center">*/}
        {/*              {row.sunday && (*/}
        {/*                  <div className="bg-emerald-100 text-emerald-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                    {row.sunday}*/}
        {/*                  </div>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*      ))}*/}
        {/*    </div>*/}
        {/*  </div>*/}

        {/*  /!* Mobile Schedule Cards *!/*/}
        {/*  <div className="lg:hidden space-y-4">*/}
        {/*    {days.map((day) => (*/}
        {/*        <div key={day} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">*/}
        {/*          <div className="bg-teal-600 text-white p-3">*/}
        {/*            <h3 className="text-lg font-semibold text-center">{day}</h3>*/}
        {/*          </div>*/}
        {/*          <div className="p-4 space-y-3">*/}
        {/*            {scheduleData.map((row, index) => {*/}
        {/*              const dayClass = row[day.toLowerCase() as keyof typeof row] as string;*/}
        {/*              if (!dayClass) return null;*/}

        {/*              return (*/}
        {/*                  <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">*/}
        {/*                    <div>*/}
        {/*                      <div className="font-medium text-gray-900 text-sm">{row.time}</div>*/}
        {/*                      <div className="text-xs text-gray-600">{row.location}</div>*/}
        {/*                    </div>*/}
        {/*                    <div>*/}
        {/*                <span className="inline-block bg-teal-100 text-teal-800 px-2 py-1 rounded text-xs font-medium">*/}
        {/*                  {dayClass}*/}
        {/*                </span>*/}
        {/*                    </div>*/}
        {/*                  </div>*/}
        {/*              );*/}
        {/*            })}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*    ))}*/}
        {/*  </div>*/}

        {/*  /!* Call to Action Section *!/*/}
        {/*  <div className="grid pt-12 md:grid-cols-1 md:gap-8 items-center text-center">*/}
        {/*    <div>*/}
        {/*      <h3 className="text-[#00889D] mb-4">Ready to Join a Class?</h3>*/}
        {/*      <div>*/}
        {/*        <a*/}
        {/*            href="/schedule"*/}
        {/*            className="inline-block bg-[#02BFA7] text-white px-12 py-6 rounded-xl font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"*/}
        {/*        >*/}
        {/*          Book a Class*/}
        {/*        </a>*/}
        {/*      </div>*/}
        {/*    </div>*/}


        {/*  </div>*/}
        {/*</div>*/}

      </section>
  );
}
